import React from "react";
import constantes from '../../resources/constantes.json';
import { fmt } from "../../utils";
import styled, { keyframes } from 'styled-components/macro';
import { useNomenclator } from "../../contexts/nomenclatorContext";
import { useTranslate } from '../../contexts/languageContext';
import { responsive } from '../../resources/constantes.json';

const candidateFoto = (codcan, codpar, tipoImg) => `${constantes.rutas.candidatos}${codcan.padStart(3, '0')}-${codpar.padStart(4, '0')}-${tipoImg}.webp`;

const CardPartidoPresidencia = ({ partido, left, horizontal }) => {
		const nomenclator = useNomenclator();
		const t = useTranslate();
		const {nombre: nombrePartido, color, codpar} = nomenclator.partidos[Number(partido.codpar) - 1]
    const basename = `${constantes.rutas.logo}${codpar.padStart(4, '0')}.png`;
    const { codcan, nomcan, apecan, nomcan2, apecan2 } = partido.cantotabla[0]
    const nomPresi = nomcan + ' ' + apecan
    const nomVice = nomcan2 + ' ' + apecan2
    return (
        <CardPartidoStyled left={left}>
            <Body left={left} horizontal={horizontal}>
							<Fotos>
								<FotoCandidato src={candidateFoto(codcan, codpar, 'P')} alt={nomPresi}/>
								<FotoCandidato src={candidateFoto(codcan, codpar, 'V')} alt={nomVice}/>
							</Fotos>
							<TextLogo>
								<Info>
									<NombreCandidato>{nomPresi}</NombreCandidato>
									<NombreCandidato>{nomVice}</NombreCandidato>
									<NomPartido>{nombrePartido}</NomPartido>
								</Info>
								<Logo>
									<img src={basename} alt={nombrePartido} />
								</Logo>
							</TextLogo>
            </Body>
							<Footer color={color} left={left} horizontal={horizontal}>
								<NumVotantes left={left} horizontal={horizontal}>{fmt(partido.vot)} {t('votos')}</NumVotantes>
								{/* <Porcentaje left={left} horizontal={horizontal}>{partido.pvot}</Porcentaje> */}
							</Footer>
        </CardPartidoStyled>
    )
}

const CardPartidoStyled = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.25);
	border-radius: 3px;
	order: ${({left}) => left ? '2' : '1'};
	width:100%;
}`


const Logo = styled.div`
	width: auto;
	padding: 5px;
	margin: 0 auto;
	display:flex;
	@media screen and (max-width: ${responsive.tablet}px) {
		flex:20%;
		width:100%;
		justify-content:flex-end;
		img{max-width:150px;}
	}
	@media screen and (max-width: ${responsive.mobile}px) {
		width:100%;
		justify-content:flex-start;
		padding: 5px 0;
		img{max-width:100px;}
	}
}`

const Body = styled.div`
	padding: 10px;
	align-items: center;
	display: flex;
	flex-direction: column;
	gap:2rem;
	height:100%;
	background: #FFFFFF;
	justify-content:space-around;
	@media screen and (max-width: ${responsive.tablet}px) {
		flex-direction: row;
		height:100%;
		order: ${({left, horizontal}) => left && horizontal ? '2' : '1'};
	}
	@media screen and (max-width: ${responsive.mobile}px) {
		justify-content:flex-start;
		// flex-wrap:wrap;
		order: ${({left, horizontal}) => left && horizontal ? '2' : '1'};
	}
}`

const Info = styled.div`
	display:flex;
	flex-direction: column;
	width:100%;
	gap: 5px;
	text-align:left;
	@media screen and (max-width: ${responsive.tablet}px) {
		flex:60%;
		justify-content:flex-start;
	}
	@media screen and (max-width: ${responsive.mobile}px) {
	}
`

const NombreCandidato = styled.div`
	display: flex;
	font-weight: 600;
	line-height: 22px;
	font-size: 16px;
	display:flex;
	@media screen and (max-width: ${responsive.mobile}px) {
		font-weight: 600;
		font-size: 12px;
		line-height: 15px;
	}
}`

const Porcentaje = styled.div`
	display:flex;
	font-weight: 600;
	font-size: 24px;
	line-height: 30px;
	display: flex;
	align-items: center;
	text-align: right;
	order: ${({left, horizontal}) => left && !horizontal ? '2' : '1'};
}`

const NumVotantes = styled.div`
	display: flex;
	font-weight: 600;
	font-size: 24px;
	line-height: 30px;
	align-items: center;
	text-align: right;
	order: ${({left, horizontal}) => left && !horizontal ? '1' : '2'};
}`

const NomPartido = styled.div`
	font-weight: 400;
	font-size: 16px;
	line-height: 20px;
	font-style: normal;
	display:flex;
	@media screen and (max-width: ${responsive.mobile}px) {
		font-weight: 400;
		font-size: 12px;
		line-height: 15px;
	}
}`

const Fotos = styled.div`
	display:flex;
	flex-direction:row;
	justify-content:center;
	width:100%;
	@media screen and (max-width: ${responsive.tablet}px) {
		flex:20%;
		justify-content:flex-start;
		width:auto;
	}
`

const FotoCandidato = styled.img`
	height: auto; 
	max-width: 50%;
	@media screen and (max-width: ${responsive.tablet}px) {
		max-width: 75px;
	}
	@media screen and (max-width: ${responsive.mobile}px) {
		// max-width: 50px;
	}
	`
	
	const Footer = styled.div`
	background-color: ${({color}) => color}; 
	display:flex;
	justify-content:center;
	min-height:100px;
	padding: 0 2rem;
	@media screen and (max-width: ${responsive.tablet}px) {
		height:75px;
		min-height:75px;
		order: ${({left, horizontal}) => left && horizontal ? '1' : '2'};
	}
	@media screen and (max-width: ${responsive.mobile}px) {
		height:50px;
		min-height:50px;
		order: ${({left, horizontal}) => left && horizontal ? '1' : '2'};
	}
}`

const TextLogo = styled.div`
	display:flex;
	flex-direction:column;
	width:100%;
	justify-content:flex-start;
	@media screen and (max-width: ${responsive.tablet}px) {
		flex-direction:row;
	}
	@media screen and (max-width: ${responsive.mobile}px) {
		flex-direction:column;
	}
`


export default CardPartidoPresidencia